import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

const FolderPageHeaderLoader = () => (
  <MainWrapper>
    <Box display="block">
      <Skeleton height={{ m: 125 }} width={{ m: 225 }} />
    </Box>
    <Box display="block" ml={{ _: 0, m: 5 }}>
      <Box display="block" mb={2}>
        <Skeleton height={30} width={150} />
      </Box>
      <Box display="block" mb={2}>
        <Skeleton height={35} width={250} />
      </Box>
    </Box>
  </MainWrapper>
);

export default FolderPageHeaderLoader;

const MainWrapper = styled(Box).attrs({
  display: 'flex',
  flexDirection: { _: 'column', m: 'row' },
  alignItems: 'start',
})``;
